/** Where the link in an invitation or password mail is meant to land. */
export const SET_PASSWORD_PATH = '/auth/set-password'

// The link types that end on the set-password page: an invitation and a password
// reset. Signing in by magic link is not offered, so nothing else is expected.
const PASSWORD_LINK_TYPES: ReadonlySet<string> = new Set(['invite', 'recovery'])

/**
 * Where a password link that landed on the wrong page belongs, or null.
 *
 * Supabase sends the person to the `redirectTo` of the mail only when that
 * address is on the project's redirect allowlist. When it is not, it falls back
 * to the Site URL without saying so, and the session from the link arrives in the
 * fragment of whatever page that is — where nothing reads it. The person then
 * sees the dashboard or the sign-in instead of the form, and the link looks
 * broken. This catches that case wherever it lands and carries the fragment on.
 *
 * A link that failed (expired, already used) is forwarded too, so the person
 * reads why and can ask for a new one, instead of a page that ignores it.
 *
 * Pure: takes the path and the fragment rather than reading `window`.
 */
export function misdirectedPasswordLink(pathname: string, hash: string): string | null {
  if (pathname === SET_PASSWORD_PATH || hash === '') return null
  const fragment = hash.replace(/^#/, '')
  const params = new URLSearchParams(fragment)
  const session = params.has('access_token') && PASSWORD_LINK_TYPES.has(params.get('type') ?? '')
  const failed = params.get('error_code') === 'otp_expired'
  return session || failed ? `${SET_PASSWORD_PATH}#${fragment}` : null
}
